import capable from '../../assets/Capability/CapilityImage.avif'

export default function Capability() {
  return (

    <section className="relative  md:py-12 md:bg-secondary-50  sm:px-6 lg:px-24 overflow-hidden">
      <div className="mx-auto max-w-7xl">

        <div className="relative flex flex-col lg:flex-row items-center gap-8 h-[600px] ">

          {/* MOBILE BACKGROUND IMAGE */}
          <img
            src={capable}
            alt="Capable"
            className="
        absolute inset-0 w-full h-full object-cover 
        lg:hidden
        "
          />

          {/* TEXT */}
          <div className="relative z-10 w-[320px] sm:w-full lg:max-w-[582px]  bg-white/70 top-72 sm:bg-transparent sm:top-0 p-3 rounded-xl">

            <h1 className="text-xl sm:text-2xl md:text-3xl xl:text-5xl font-semibold text-black">
              Systems Built For
              <span className="text-secondary-500 "> Real Business Performance</span>
            </h1>

            <p className="text-gray-700 text-sm sm:text-base md:text-lg xl:text-xl pt-4 font-secondary ">
              We design and engineer digital platforms that support growth, efficiency, and long-term reliability.
            </p>

            <p className="text-gray-700 text-sm sm:text-base md:text-lg xl:text-xl pt-4 font-secondary ">
              Our capabilities combine engineering depth, intelligent systems, thoughtful design, and connected technologies, all built around real-world workflows.
            </p>

          </div>

          {/* DESKTOP IMAGE */}
          <div className="hidden lg:flex w-full justify-end">
            <img
              src={capable}
              alt="Capable"
              className="max-w-[520px] w-full object-contain"
            />
          </div>

        </div>

      </div>
    </section>
  )
}

